import { put, call, delay } from 'redux-saga/effects';

import { Types } from './actions';

import RectificationRepository from '@/domain/repositories/RectificationRepository';
import RectificationNotesDataRepository from '@/data/repositories/RectificationNotesDataRepository';

export default function* execute(action: any): any {
  try {
    const { RectificationRegisterRequest } = action;
    yield put({ type: Types.REGISTER_RECTIFICATION_OF_GRADE_REQUEST });

    const rectificationRepository: RectificationRepository =
      new RectificationNotesDataRepository();
    yield call(
      rectificationRepository.RegisterRectificationOfGrade,
      RectificationRegisterRequest
    );

    yield delay(3500);
    yield put({
      type: Types.REGISTER_RECTIFICATION_OF_GRADE_SUCCESS,
      data: { registerRectificationOfGrade: { requestId: 1, error: null } }
    });
  } catch (error) {
    yield put({
      type: Types.REGISTER_RECTIFICATION_OF_GRADE_FAILURE,
      error: 'Ocurrió un error al momento de solicitar los datos.'
    });
  }
}
